<div class="loader-container" [class.center]="center">
  <div class="spinner"></div>
  <p>{{ text | translate }}</p>
</div>